import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data-found',
  standalone: false,
  templateUrl: './no-data-found.component.html'
})
export class NoDataFoundComponent {
  @Input() imgSrc!:string
  @Input() title!:string
  @Input() msg!:string

}
